import React, { useState, useEffect,useContext } from 'react'
import { Nav, Navbar, NavDropdown } from 'react-bootstrap'
import {context} from '../../context'

const Grades = () => {
    const [grade, setGrade] = useState([])
    const {setShowItem,id, setId} = useContext(context)

    useEffect(() => {
        fetch('https://englishtutorial1.somee.com/api/grades/GetAllGrades')
            .then(json => json.json())
            .then(data => setGrade(data))
    },[])

    return (
        <div className="navbar-nav">
            <NavDropdown title="Grade-sheets" id="basic-nav-dropdown" style={{ fontSize: "1.4rem", paddingRight: "1.4rem" }}>
                {grade.map(grade =>
                    <NavDropdown.Item onClick={()=>{setId(grade.Id);setShowItem('grades')}}>{grade.GradeName}</NavDropdown.Item>)}
            </NavDropdown>
        </div>
    )
}

export default Grades


// const fetchGrades = ()=> {
//     
//         `<div className="navbar-nav"><NavDropdown title="Grade-sheets" id="basic-nav-dropdown" style={{ fontSize: "1.4rem", paddingRight: "1.4rem" }}>
//         <NavDropdown.Item href="Grade.js">${data.GradeName}</NavDropdown.Item></div>`
//     })
// }

    // return (
    //     <div className="navbar-nav">
    //         <NavDropdown title="Grade-sheets" id="basic-nav-dropdown" style={{ fontSize: "1.4rem", paddingRight: "1.4rem" }}>
    //             <NavDropdown.Item href="Grade.js">Grade 1</NavDropdown.Item>
    //             <NavDropdown.Item href="#action/3.2">Grade 2</NavDropdown.Item>
    //             <NavDropdown.Item href="#action/3.3">Grade 3</NavDropdown.Item>
    //         </NavDropdown>
    //     </div>
    // )